import { render, staticRenderFns } from "./Aviso.vue?vue&type=template&id=05d68200"
import script from "./Aviso.vue?vue&type=script&lang=ts"
export * from "./Aviso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports